import { createContext } from 'react';
import { IGetDishInfoV2, IItemForGetShortInfo, IItemForGetShortDishInfo } from 'types';

export interface ISuggestedModalState {
	dishInfo: Nullable<IGetDishInfoV2['data']>;
	IDsSelectedRestaurant: string[];
	selectedSuggestedDishCategory: Nullable<string>;
	selectedSuggestedDishSubCategory: Nullable<string>;
	selectedSuggestedDishes: string[];
	fetchedSuggestedDishes: IItemForGetShortDishInfo[];
}

export const suggestedModalInitialState: ISuggestedModalState = {
	dishInfo: null,
	IDsSelectedRestaurant: [],
	selectedSuggestedDishCategory: null,
	selectedSuggestedDishSubCategory: null,
	fetchedSuggestedDishes: [],
	selectedSuggestedDishes: [],
};

export interface ISuggestedModalContext extends ISuggestedModalState {
	setSuggestedDishCategory(value: Nullable<string>): void;
	setSuggestedDishSubCategory(value: Nullable<string>): void;
	setFetchedSuggestedDishes(value: IItemForGetShortInfo[]): void;
	setSuggestedDishes(value: string[]): void;
	removeSuggestedDish(value: string): void;
}

export const SuggestedModalContext = createContext<ISuggestedModalContext>({
	setSuggestedDishCategory: () => undefined,
	setSuggestedDishSubCategory: () => undefined,
	setFetchedSuggestedDishes: () => undefined,
	setSuggestedDishes: () => undefined,
	removeSuggestedDish: () => undefined,
	...suggestedModalInitialState,
});
